import { Typography } from 'design-system/src/components/Typography/Typography';
import { InfoBox } from 'design-system/src/components/InfoBox/InfoBox';
import Banner from 'design-system/src/components/Banner/Banner';

interface PharmaRelationshipNoticeProps {
  /**
   * Whether the notice should appear as a vertical card (for a sidebar) or a horizontal banner (that goes across the main page content).
   *
   * Default is 'vertical'.
   */
  variant?: 'banner' | 'card';
  className?: string;
}

/**
 * A notice banner about premium drug features.
 */
export const PharmaRelationshipNotice = ({ variant = 'card', className }: PharmaRelationshipNoticeProps) => {
  const copy =
    "Tandem established a business relationship with the pharmaceutical manufacturer that results in a differentiated user experience. There may be lower cost medications available or preferred on the patient's plan.";

  if (variant === 'card') {
    return (
      <InfoBox variant="transparent" noBottomMargin noTopMargin className={className}>
        <Typography styledAs="bodyExtraSmallDMSans">{copy}</Typography>
      </InfoBox>
    );
  } else {
    return <Banner variant="neutral" description={copy} className={className} />;
  }
};

export default PharmaRelationshipNotice;
